
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Faire son site Internet seul : vraiment ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous vous sentez prêt à mettre les mains dans le cambouis grâce aux outils en ligne disponibles sur la Toile et à créer votre site tout seul. Bonne idée ou pas ?",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Faire son site Internet seul : vraiment ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous vous sentez prêt à mettre les mains dans le cambouis grâce aux outils en ligne disponibles sur la Toile et à créer votre site tout seul. Bonne idée ou pas ?",
        },
      ],
    };
  },
};
